import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/images/login/close2.png';
import _imports_1 from '@/assets/images/login/logo.png';
const _hoisted_1 = { class: "login_phone flexColumn-alc" };
const _hoisted_2 = { class: "flexColumn lp_title" };
const _hoisted_3 = { class: "lpt_welcome" };
const _hoisted_4 = { class: "flexColumn lpt_nav" };
const _hoisted_5 = { class: "lptn_item flexRow-alc" };
const _hoisted_6 = { class: "i_color lptn_tip" };
const _hoisted_7 = { class: "lp_form flexColumn-alc flex-jcc" };
import { reactive, ref } from 'vue';
import config from '@/api/config';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import request from '@/api/request';
import loginForm from './login_form.vue';
import apiUrl from '@/api/apiUrl';
import { encryptAES } from '@/utils/crypto';
export default /*@__PURE__*/ _defineComponent({
    __name: 'login_phone',
    emits: ['close', 'loginSuccess', 'forgetPassword', 'register'],
    setup(__props, { emit: __emit }) {
        const router = useRouter();
        const route = useRoute();
        const store = useStore();
        const loginIndex = ref(1);
        const loginFormRef = ref();
        const loginDict = reactive([{
                name: '验证码',
                value: 'code',
                tips: '未注册的手机号验证码验证后自动注册'
            }, {
                name: '账号密码',
                value: 'password',
                tips: '如果没有账号密码请先注册'
            }]);
        const handleNav = (event) => {
            var _a;
            loginIndex.value = event || 0;
            (_a = loginFormRef.value) === null || _a === void 0 ? void 0 : _a.resetForm();
        };
        const emits = __emit;
        const handleForgetPassword = () => {
            var _a;
            let getMobile = ((_a = loginFormRef.value) === null || _a === void 0 ? void 0 : _a.getMobile()) || '';
            emits('forgetPassword', JSON.parse(JSON.stringify(getMobile)));
        };
        const loading = ref(false);
        // 登录
        const submitLogin = async (datas) => {
            loading.value = true;
            try {
                await (loginIndex.value == 0 ? loginCode(datas) : loginPassword(datas));
            }
            catch (err) { }
            loading.value = false;
        };
        // 验证码登录
        const loginCode = async (datas) => {
            let res;
            try {
                res = await request.post(apiUrl.smsLogin, {
                    mobile: encryptAES(datas.mobile),
                    code: encryptAES(String(datas.code)),
                });
            }
            catch (error) { }
            // 登录错误
            if ((res === null || res === void 0 ? void 0 : res.code) !== 0)
                return;
            loginSuccess(res);
        };
        // 密码登录
        const loginPassword = async (datas) => {
            let res;
            try {
                res = await request.post(apiUrl.authLogin, {
                    mobile: encryptAES(datas.mobile),
                    password: encryptAES(datas.password),
                });
            }
            catch (error) { }
            // 登录错误
            if ((res === null || res === void 0 ? void 0 : res.code) !== 0)
                return;
            loginSuccess(res);
        };
        const loginSuccess = (res) => {
            var _a, _b, _c, _d;
            // 登录成功
            store.commit('setModelListKey', ((_b = (_a = store.state.modelList.list) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.id) || '');
            localStorage.setItem('token', ((_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.refreshToken) || '');
            store.commit('setToken', ((_d = res === null || res === void 0 ? void 0 : res.data) === null || _d === void 0 ? void 0 : _d.refreshToken) || '');
            emits('loginSuccess', res === null || res === void 0 ? void 0 : res.data);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: "lp_close clickable",
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close')))
                }, _cache[4] || (_cache[4] = [
                    _createElementVNode("img", { src: _imports_0 }, null, -1)
                ])),
                _createElementVNode("aside", _hoisted_2, [
                    _createElementVNode("p", _hoisted_3, "欢迎登录" + _toDisplayString(_unref(config).brand_name), 1),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("span", {
                                class: _normalizeClass(["clickable lptn_text", { 'lptn_text_active': loginIndex.value == 1 }]),
                                onClick: _cache[1] || (_cache[1] = ($event) => (handleNav(1)))
                            }, _toDisplayString(loginDict[1].name), 3),
                            _cache[5] || (_cache[5] = _createElementVNode("span", { style: { "margin": "0 6px", "color": "#D9D9D9" } }, "|", -1)),
                            _createElementVNode("span", {
                                class: _normalizeClass(["clickable lptn_text", { 'lptn_text_active': loginIndex.value == 0 }]),
                                onClick: _cache[2] || (_cache[2] = ($event) => (handleNav(0)))
                            }, _toDisplayString(loginDict[0].name), 3)
                        ]),
                        _createElementVNode("p", _hoisted_6, _toDisplayString(loginDict[loginIndex.value].tips), 1)
                    ]),
                    _cache[6] || (_cache[6] = _createElementVNode("img", {
                        src: _imports_1,
                        class: "lpt_logo"
                    }, null, -1))
                ]),
                _createElementVNode("aside", _hoisted_7, [
                    _createVNode(loginForm, {
                        ref_key: "loginFormRef",
                        ref: loginFormRef,
                        showModules: ['plioy', loginIndex.value == 0 ? 'code' : 'password', 'forgetPassword'],
                        onForgetPassword: handleForgetPassword,
                        onSubmit: submitLogin,
                        onSwitchNav: handleNav
                    }, null, 8, ["showModules"])
                ]),
                _createElementVNode("aside", {
                    class: "clickable flexRow-alc flex-jcc",
                    style: { "margin-top": "10px" },
                    onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.$emit('register')))
                }, "注册")
            ]));
        };
    }
});
